// extracted by mini-css-extract-plugin
export default {"marker":"marker_marker__tlIfx","popup":"marker_popup__YxbrD"};